<template>
  <div class="page">
    <div class="banner">
      <!-- 	<div class="banner_title">
				<h1>一站式签证专家</h1>
				<p>全国连锁 | 专注签证行业20年</p>
			</div> -->

      <div class="search">
        <div class="search_input_box">
          <!-- <el-input v-model="searchTxet" size="medium" placeholder="搜索办理签证的国家或地区"></el-input> -->
          <el-select style="width: 100%;" v-model="searchTxet" filterable remote :remote-method="SeachCountry"
            placeholder="搜索办理签证的国家或地区" @change="changeSeach">
            <el-option v-for="item in SeachCountryList" :key="item.id" :label="item.zh_name" :value="item">
            </el-option>
          </el-select>
          <el-button type="primary">搜索</el-button>
        </div>

        <div class="search_input_hot">
          <div>
            大家都在搜：
          </div>
          <div class="search_input_hot_item" v-for="(item,index) in search_hotCountry"
            @click="goLink('/detail?id=' + item.id + '&County=' + item.zh_name)">
            {{item.zh_name}}
          </div>
        </div>
      </div>

      <el-carousel height="33.75rem">
        <el-carousel-item v-for="(item,index) in banner" :key="index">
          <!-- <img :src="item.BannerImgPath"> -->
          <img :src="item.src" @click="goLink(item.url)">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="hot_country">
      <div class="hot_country_box">
        <el-header class="hot_country_head">
          <div class="hot_country_head1">
            热门产品
          </div>
          <div class="hot_country_head2">
            POPULAR COUNTRIES
          </div>
        </el-header>
        <div class="hot_country_main">
          <div class="item" v-for="(item,index) in hotCountry" :key="index">
            <div class="item_img">
              <img :src="item.BgImgPath">
            </div>
            <div class="item_price">
              <div>
                <div class="item_price_title">
                  {{item.VisaTitle}}
                </div>
                <div class="item_prices">
                  ￥{{item.Price1}}
                </div>
              </div>

              <div class="item_price_btn">
                <div class=""
                  @click="goLink('/detail?id=' + item.CountryId + '&County=' + item.CountryName + '&detail=' + item.Id)">
                  立即抢购
                </div>

              </div>
            </div>
          </div>

          <el-button @click="GoCountryList" type="primary">查看更多</el-button>
        </div>
      </div>
    </div>

    <div class="appointment_date">
      <div class="appointment_date_main">
        <div class="">
          <div class="appointment_date_main_title">
            预约动态
          </div>

          <div class="appointment_table">
            <div class="appointment_table_title">
              <div>
                国家
              </div>
              <div>
                领区城市
              </div>
              <div>
                预约日期
              </div>
              <div>
                更新日期
              </div>
            </div>

            <div class="appointment_table_main">
              <div class="appointment_table_main_left" ref="appointment">
                <div class="appointment_table_main_left_item"
                  :class="appointmentActive == index ? 'appointment_table_main_left_active' : ''"
                  v-for="(item,index) in appointmentList" :key="item" @click="changeAppointment(index)">
                  {{item}}
                </div>

                <div class="rollTop" @click="scrollHei('up','appointment')" v-if="appointmentList.length > 6">
                  <i class="el-icon-arrow-up"></i>
                </div>

                <div class="rollBottom" @click="scrollHei('down','appointment')" v-if="appointmentList.length > 6">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <div class="appointment_table_main_right" v-loading="appointmentLoading">
                <div v-if="appointmentTableList !== null && appointmentTableList.length > 0"
                  class="appointment_table_main_right_item">
                  <div v-for="(item,index) in appointmentTableList" :key="item.Id" class="">
                    <div class="">
                      {{item.Consular}}
                    </div>
                    <div class="">
                      {{(item.BookDate=='0001/01/01' || item.BookDate=='0001-01-01' || item.BookDate=='1900-01-01' || item.BookDate=='1900/01/01')?"无号可约":item.BookDate}}
                    </div>
                    <div class="">
                      {{item.UpdateTime}}
                    </div>
                  </div>
                </div>
                <div v-else class="appointment_table_main_right_tips">
                  <el-empty :image-size="100"></el-empty>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <div class="appointment_date_main_title">
            领馆假期
          </div>

          <div class="vacation_table">
            <div class="vacation_table_title">
              <div>
                国家
              </div>
              <div>
                节假日
              </div>
              <div>
                放假日期
              </div>
            </div>

            <div class="vacation_table_main">
              <div class="vacation_table_main_left" ref="vacation">
                <div class="vacation_table_main_left_item"
                  :class="vacationActive == index ? 'vacation_table_main_left_active' : ''"
                  v-for="(item,index) in  vacationList" :key="item" @click="changeVacation(index)">
                  {{item}}
                </div>

                <div class="rollTop" @click="scrollHei('up','vacation')" v-if="vacationList.length > 6">
                  <i class="el-icon-arrow-up"></i>
                </div>

                <div class="rollBottom" @click="scrollHei('down','vacation')" v-if="vacationList.length > 6">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <div class="vacation_table_main_right" v-loading="vacationLoading">
                <div v-if="vacationTableList != null && vacationTableList.length > 0"
                  class="vacation_table_main_right_item">
                  <div v-for="(item,index) in vacationTableList" :key="item.Id" class="">
                    <div class="">
                      {{item.HolidayName}}
                    </div>
                    <div class="">
                      {{item.HolidayDate}}
                    </div>
                  </div>
                </div>

                <div v-else class="vacation_table_main_right_tips">
                  <el-empty :image-size="100"></el-empty>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="we">
      <div class="we_box">
        <el-header class="we_box_head">
          <div class="we_box_head1">
            关于我们
          </div>
          <div class="we_box_head2">
            ABOUT US
          </div>
        </el-header>

        <div class="we_main">
          <div class="we_main_left">
            <div class="we_main_left_title">
              虎翼掌上签
            </div>

            <div class="we_main_left_text">
              虎翼掌上签拥有一支经验丰富的专业化签证服务团队，深谙各国签证的
              政策原则以及最新动向，可以根据申请人自身情况为客户策划详尽有效
              的签证申请方案，提供签证申请流程的全程指导，协助申请人准备签证
              申请材料和文件，提供专业化的模拟面试培训，快速为客户提供签证代
              取、代送业务，20年以来签证成功通过率接近100%。
            </div>

            <el-button @click="GoAbout" type="primary" size="medium">查看更多</el-button>
          </div>

          <div class="we_box_right">
            <img src="https://file.aavisa.com/browser-upload-file/e9468b61-021b-47aa-857d-b2bdb08a72e6.jpg">
            <img class="we_box_right_code"
              src="https://file.aavisa.com/browser-upload-file/1c6b09d8-b84d-42c5-84d0-e4cb87bc17f0.jpg">
          </div>
        </div>

        <div class="we_box_footer">
          <div class="">
            <div class="">
              2,000,000
              <span>+人次</span>
            </div>
            <div class=""></div>
            <div class="">
              服务人次
            </div>
          </div>
          <div class="">
            <div class="">
              100
              <span>+人</span>
            </div>

            <div class=""></div>
            <div class="">
              顾问团队
            </div>
          </div>

          <div class="">
            <div class="">
              12
              <span>个</span>
            </div>
            <div class=""></div>
            <div class="">
              全国分部
            </div>
          </div>
          <div class="">
            <div class="">
              20
              <span>年</span>
            </div>
            <div class=""></div>
            <div class="">
              行业经验
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="consult">
      <el-header class="consult_head">
        <div class="consult_head1">
          签证资讯
        </div>
        <div class="consult_head2">
          LATEST INFORMATION
        </div>
      </el-header>

      <div class="consult_main">
        <div class="" style="cursor: pointer;" v-for="(item,index) in NewsConsultList" :key="item.Id"
          @click="goLink('/newsdetails?id=' + item.Id)">
          <el-image style="width: 21.5rem;height: 11.625rem;" :src="'https://www.aavisa.com' + item.NewsImagePath"
            fit="fill"></el-image>
          <div class="NewsConsult_title">
            {{item.NewsTitle}}
          </div>

          <div class="NewsConsult_desc">
            {{item.NewsDesc}}
          </div>

          <div class="NewsConsult_Time">
            {{item.CreateTime}}
          </div>
        </div>
      </div>

      <el-button @click="GoConsultList" type="primary">查看更多</el-button>
    </div>
    <div style="display: none">{{timestamp}}</div>
    <login ref="login" :Id="Id" :Register="Register"></login>
    <div class="maks1" v-if="qrcode">
  <div class="qrcode1">       
    <i class="el-icon-close" @click="qrcode = false"></i>
    <img src="https://file.aavisa.com/browser-upload-file/song.png" @click="goLink('/personcenter')" />
  </div>
  </div>
  </div>  
</template>



<script>
  import login from '../../components/login/login.vue';
  export default {
    data() {
      return {
        qrcode:false,
        banner: [
          // {
          //   src: 'https://file.aavisa.com/browser-upload-file/a717746c-8f4b-434f-ae7d-b3fec356d8b9.jpg',
          //   url: '/activity'
          // },
           {
            src: 'https://file.aavisa.com/browser-upload-file/4701b9a6-cda3-42f7-986d-83f1b046f61d.jpg',
            url: ''
          }, {
            src: 'https://file.aavisa.com/browser-upload-file/8bc62a35-dce9-4c52-8f55-fbbbe98b6ec0.jpg',
            url: ''
          }, {
            src: 'https://file.aavisa.com/browser-upload-file/8482e209-f842-42fe-ac97-7f8a6ba1724b.jpg',
            url: ''
          }
          // 'https://file.aavisa.com/browser-upload-file/1679f5db-94f3-4405-bbae-e2c74384829a.jpg'
        ],
        // 搜索框下热门城市
        search_hotCountry: [{
            zh_name: '日本',
            id: '67'
          },
          {
            zh_name: '美国',
            id: '180'
          },
          {
            zh_name: '马来西亚',
            id: '93'
          },
          {
            zh_name: '新加坡',
            id: '62'
          },
          {
            zh_name: '澳大利亚',
            id: '184'
          },
          {
            zh_name: '泰国',
            id: '71'
          },
          {
            zh_name: '英国',
            id: '161'
          },
          {
            zh_name: '韩国',
            id: '63'
          },
          {
            zh_name: '越南',
            id: '69'
          },
          {
            zh_name: '法国',
            id: '163'
          },
        ],
        searchTxet: '',

        // 热门国家
        hotCountry: [

        ],
        SeachCountryList: [],


        appointmentList: [], //预约国家
        appointmentActive: 0, //预约国家索引
        appointmentTableList: [], // 预约国家日期内容
        appointmentLoading: false, //预约国家加载

        vacationList: [], //领馆国家
        vacationActive: 0, //领馆国家索引
        vacationTableList: [], // 领馆国家日期内容
        vacationLoading: false, //预约国家加载

        NewsConsultList: [], //签证资讯
        Register: false,
        timestamp: '',
        Id: 'login_container1',
      };
    },
    components: {
      login
    },
    created() {
      this.checkFirstLogin()
      this.getCountry()
      this.GetNewsConsult()
    },

    beforeMount() {
      if (this.$route.query.code) {
        this.CheckCodeLogin(this.$route.query.code)
      }
    },
    mounted() {
      if (this.$route.query.timestamp) {
        this.timestamp = this.$route.query.timestamp

        this.$nextTick(() => {
          this.Register = true
        })
      }

      this.GetHotSearchCuntry()

    },

    methods: {
      scrollHei(str, refs) {
        if (str == 'up') {
          this.$refs[refs].scrollTop = 0
        } else if (str == 'down') {
          this.$refs[refs].scrollTop = this.$refs[refs].scrollHeight
        }
      },
      GetHotSearchCuntry() {
        this.$api.GetHotSearchCuntry().then(res => {
          console.log(res)
          let {
            data,
            status
          } = res.data;
          if (status == 200) {
            this.search_hotCountry = data.data.slice(0, 10)
          }
        })
      },

      CheckCodeLogin(code) {
        if ((cookie.get('auth') && cookie.get('MemberId') && cookie.get("PcMemberId"))) return false
        let isLogin = cookie.get('isLogin') == 'true' ? true : false;
        if (isLogin) return
        cookie.set('isLogin', true)
        this.$api.CheckCodeLogin({
          Code: code
        }).then(res => {
          console.log(res)

          if (res.data.result) {
            cookie.set('auth', res.data.data.token, {
              expires: 99999
            })
            cookie.set('MemberId', res.data.data.Id, {
              expires: 99999
            })
            cookie.set('storeId', res.data.data.StoreId, {
              expires: 99999
            })
            cookie.set('Contacts', res.data.data.Contacts, {
              expires: 99999
            })
            this.Contacts = cookie.get('Contacts')
            cookie.set('isLogin', false)
            this.$router.push('/')
            location.reload();
          } else {
            cookie.set('isLogin', false)
            this.$router.push('/')
            location.reload();
            this.$message.error(res.data.message)
          }
        }).catch(err => {
          cookie.set('isLogin', false)
          window.location = 'https://www.aavisa.com/?timestamp=' + new Date().getTime()
          this.$message.error("您还未注册同业账户，请扫码注册！")

        })
      },

      goLink(url) {
        if (!url) return false;
        this.$router.push(url)
      },

      getBanner() {
        this.$api.GetBanner().then(res => {
          console.log('res', res.data.data)
          this.banner = res.data.data
        })
      },
      changeSeach(value) {
        this.$router.push(`/detail?id=${value.id}&County=${value.zh_name}`)
      },
      SeachCountry(value) {

        this.$api.SeachCountry({
          keys: value
        }).then(res => {
          let {
            data,
            status
          } = res.data;
          if (status == 200) {
            console.log(data)
            this.SeachCountryList = data.data;

          }
        })
      },

      getCountry() {
        this.GetCountryBookList()
        this.GetCountryHolidayList()
        this.GetHotCountry()
      },
      checkFirstLogin(){
        if(cookie.get('auth')){          
          var st=cookie.get('ShowTime')
          var today=new Date().getFullYear()+"-" + (new Date().getMonth() + 1).toString().padStart(2, '0') + "-" +  new Date().getDate().toString().padStart(2, '0');
          if(st==today){
            this.qrcode=false                           
          }
          else{         
            this.qrcode=true       
            cookie.set('ShowTime', new Date().getFullYear()+"-" + (new Date().getMonth() + 1).toString().padStart(2, '0') + "-" +  new Date().getDate().toString().padStart(2, '0'),{
              expires: 99999
            })
          }              
        }
      },
      GetHotCountry() {
        this.$api.GetHotProduct({
          ShengName: ''
        }).then(res => {
          let {
            data,
            result
          } = res.data
          console.log(data, res, 'GetHotProduct')
          if (result) {
            this.hotCountry = data.DataList.slice(0, 8)
          }
        })
      },
      // 预约国家
      GetCountryBookList() {
        this.$api.GetCountryBookList().then(res => {
          let {
            data,
            status
          } = res.data
          if (status == 200) {
            this.appointmentList = data
            this.GetCountryBook(this.appointmentActive)
          }
        })
      },

      // 预约国家
      GetCountryBook(index) {
        this.appointmentLoading = true
        this.$api.GetCountryBook({
          Country: this.appointmentList[index]
        }).then(res => {
          let {
            data,
            status
          } = res.data
          if (status == 200) {
            this.appointmentTableList = data.DataList
          } else {
            this.appointmentTableList = []
          }
          this.appointmentLoading = false
        }).catch(err => {
          this.appointmentTableList = []
          this.appointmentLoading = false
          console.log(err)
        })
      },

      // 领馆国家
      GetCountryHolidayList() {
        this.$api.GetCountryHolidayList().then(res => {
          let {
            data,
            status
          } = res.data
          if (status == 200) {
            this.vacationList = data.slice(0, 6)
            this.GetCountryHoliday(this.vacationActive)
          }
        })
      },

      // 假期领馆
      GetCountryHoliday(index) {
        this.vacationLoading = true
        this.$api.GetCountryHoliday({
          Country: this.vacationList[index]
        }).then(res => {
          let {
            data,
            status
          } = res.data
          if (status == 200) {
            let list = data.DataList
            for (let i in list) {
              if (list[i].HolidayDate.indexOf(',') != -1) {
                let arr = list[i].HolidayDate.split(',')
                list[i].HolidayDate = arr[0] + '至' + arr[arr.length - 1]
              }
            }
            this.vacationTableList = list
          } else {
            this.vacationTableList = []
          }
          this.vacationLoading = false
        }).catch(err => {
          this.vacationTableList = []
          this.vacationLoading = false
          console.log(err)
        })
      },

      // 预约国家点击事件
      changeAppointment(index) {
        this.appointmentActive = index;
        this.GetCountryBook(index);
      },

      // 假期领馆点击事件
      changeVacation(index) {
        this.vacationActive = index;
        this.GetCountryHoliday(index);
      },

      // 获取签证资讯
      GetNewsConsult() {
        this.$api.GetNewsConsult({
          PageIndex: 1,
          PageSize: 6
        }).then(res => {
          let {
            data,
            result
          } = res.data
          console.log(res.data)
          if (result) {
            // 转换时间格式
            let TimeList = data.DataList
            TimeList = TimeList.map((item, index) => {
              const timestamp = parseInt(item.CreateTime.match(/\d+/)[0]);
              const date = new Date(timestamp);
              const formattedTime =
                `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
              return {
                ...data.DataList[index],
                CreateTime: formattedTime,
              };
            });

            this.NewsConsultList = TimeList
          } else {
            this.NewsConsultList = []
          }
        })
      },

      GoConsultList() {
        this.$router.push({
          path: '/news'
        })
      },

      GoCountryList() {
        this.$router.push({
          path: '/activity'
        })
      },

      GoAbout() {
        this.$router.push({
          path: '/aboutus'
        })
      }
    },
  };

</script>



<style lang='less' scoped>
  .page {
    width: 100%;
    margin: 0 auto;

    .banner {
      width: 100%;
      height: 33.75rem;
      position: relative;
      overflow: hidden;
      z-index: 0;

      .el-carousel__item img {
        width: 100%;
        height: 100%;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
      }

      .banner_title {
        position: absolute;
        left: 50%;
        top: 10%;
        transform: translate(-50%, 0);
        z-index: 99;

        &>h1 {
          font-size: 4.3rem;
          letter-spacing: 0.4975rem;
          color: #fff;
        }

        &>p {
          font-size: 1.8rem;
          letter-spacing: 0.5rem;
          color: #fff;
          margin-top: -1.2rem;
        }
      }

      .search {
        position: absolute;
        left: 50%;
        top: 61.5%;
        transform: translate(-50%, 0);
        z-index: 99;
        width: 60.5%;
        height: 6.25rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: rgba(138, 138, 138, 0.7);
        padding: 10px;
        border-radius: 6px;

        .search_input_box {
          width: 100%;
          height: 3.75rem;
          background-color: #fff;
          border-radius: 5px;
          display: flex;

          .el-button {
            background-color: #599fff !important;
            border-color: #599fff !important;
            padding-left: 2.625rem;
            padding-right: 2.625rem;
            margin: 0.25rem;
            font-size: 1rem;
          }

          /deep/.el-input {
            height: 100%;

          }

          /deep/ .el-input__inner {
            height: 100% !important;
            border: none !important;
            border-color: rgba(0, 0, 0, ) !important;
            font-size: 1.15rem !important;
          }

          /deep/ .el-input__inner::placeholder {
            font-size: 1.15rem !important;
          }

          /deep/ .el-input__inner:focus {
            border: none !important;
            border-color: rgba(0, 0, 0, ) !important;
          }

        }

        .search_input_hot {
          width: 100%;
          height: 2.5rem;
          display: flex;
          align-items: flex-end;
          color: #fff;
          font-size: 1rem;

          .search_input_hot_item {
            padding: 0 1.275rem;
            cursor: pointer;
          }
        }
      }
    }

    .hot_country {

      width: 100%;
      height: 53.4375rem;
      background-color: #fff;

      .hot_country_box {
        width: 62.5%;
        height: 100%;
        margin: 0 auto;

        .hot_country_head {
          padding-top: 4.2875rem;
          padding-bottom: 2.8125rem;
          width: 100%;
          height: auto !important;

          .hot_country_head1 {
            font-size: 2rem;
            font-weight: 600;
            margin-bottom: 0.85rem;
          }

          .hot_country_head2 {
            font-size: 1.125rem;
            color: #cccccc;
            font-weight: 600;
          }
        }

        .hot_country_main {
          width: 100%;
          height: auto !important;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 0 !important;

          .item {
            width: 23.3%;
            height: 16.5625rem;
            margin-bottom: 1.25rem;

            .item_img {
              width: 100%;
              height: 12.5rem;
              position: relative;

              .mark {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, .3);
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                font-size: 1.5rem;
                color: #fff;

                &>div {
                  width: 3.125rem;
                  height: 0.125rem;
                  background-color: #fff;
                  text-align: center;
                }
              }

              &>img {
                width: 100%;
                height: 100%;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
              }
            }

            .item_price {
              font-size: 0.75rem;
              background-color: #dcdcdc;
              display: flex;
              border-bottom-left-radius: 8px;
              border-bottom-right-radius: 8px;
              height: 4.4rem;

              &>div:nth-child(1) {
                width: 58%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;
                text-align: left;
                padding-left: 2%;
                margin-top: 0.1875rem;

                .item_price_title {
                  width: 100%;
                }

                .item_prices {
                  width: 100%;
                  color: #ff8033;
                  font-weight: 600;
                }
              }

              .item_price_btn {
                width: 40%;
                position: relative;

                &>div {
                  width: 5.375rem;
                  height: 2.1rem;
                  background-color: #ff8033;
                  border-radius: 50px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  color: #fff;
                  text-align: center;
                  line-height: 2.1rem;
                  cursor: pointer;
                }
              }
            }
          }

          .el-button {
            background-color: #599fff !important;
            border: #599fff !important;
            margin: 0.625rem auto 0;
            padding: 0.75rem 2.5rem;
          }
        }
      }
    }

    .appointment_date {
      width: 100%;
      height: 25.625rem;
      background-image: url(https://file.aavisa.com/browser-upload-file/65f43968-15cb-4f1a-97a1-615750621492.jpg);
      padding: 4.875rem 0 5rem 0;

      .appointment_date_main {
        width: 62.5%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        &>div {
          width: 49%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .appointment_date_main_title {
            font-size: 2rem;
            text-align: left;
            font-weight: 600;
            color: #fff;
          }

          .vacation_table {
            height: 21.625rem;
            background-color: #fff;
            border-radius: 12px;

            .vacation_table_title {
              width: 100%;
              height: 2.8125rem;
              box-sizing: border-box;
              border-bottom: 1px solid #d1d1d1;
              display: flex;
              align-items: center;
              padding: 0 1.25rem;
              font-size: 0.875rem;

              &>div:nth-child(1) {
                width: 5.5rem;
              }

              &>div:nth-child(2) {
                width: 12.3125rem;
                margin-left: 3.4375rem;
                text-align: left;
              }

              &>div:nth-child(3) {
                width: 9.875rem;
                text-align: left;
              }


            }

            .vacation_table_main {
              height: 18.625rem;
              padding: 0 1.25rem;
              display: flex;
              align-items: center;
              position: relative;

              .vacation_table_main_left::-webkit-scrollbar {
                width: 0.125rem !important;
              }

              .vacation_table_main_left::-webkit-scrollbar-track {
                background-color: #F0F0F0;
                border-radius: 10px;
                width: 0.25rem !important;
              }

              .vacation_table_main_left {
                width: 5.5rem;
                height: 15rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                overflow-x: auto;

                .rollTop {
                  width: 5.5rem;
                  height: 2.5rem;
                  line-height: 2.5rem;
                  text-align: center;
                  position: absolute;
                  top: 0rem;

                  &>i {
                    font-size: 1.4375rem;
                    cursor: pointer;
                  }
                }

                .rollBottom {
                  width: 5.5rem;
                  height: 2.5rem;
                  line-height: 2.5rem;
                  text-align: center;
                  position: absolute;
                  bottom: -0.225rem;

                  &>i {
                    font-size: 1.4375rem;
                    cursor: pointer;
                  }
                }

                .vacation_table_main_left_item {
                  width: 100%;
                  height: 2.5rem;
                  line-height: 2.5rem;
                  text-align: center;
                  font-size: 0.875rem;
                  color: #999;
                  background-color: #f7f8f8;
                  position: relative;
                }

                .vacation_table_main_left_active {
                  color: #000 !important;
                  background-color: #fff !important;
                }

                .vacation_table_main_left_active:before {
                  content: "";
                  display: block;
                  width: 0.25rem;
                  height: 1.125rem;
                  background-color: #599fff;
                  position: absolute;
                  left: 0;
                  top: calc(50% - 0.5625rem);
                  border-radius: 10px;
                }
              }

              .vacation_table_main_right::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background-color: #599fff;
              }

              .vacation_table_main_right::-webkit-scrollbar {
                width: 0.25rem !important;
              }

              .vacation_table_main_right::-webkit-scrollbar-track {
                background-color: #F0F0F0;
                border-radius: 10px;
                width: 0.25rem !important;
              }

              .vacation_table_main_right {
                width: 28.75rem;
                height: 15rem;
                overflow-y: auto;

                .vacation_table_main_right_item {
                  width: 100%;
                  height: 100%;

                  &>div {
                    width: 100%;
                    height: 2.5rem;
                    display: flex;
                    align-items: center;
                    font-size: 0.875rem;

                    &>div:nth-child(1) {
                      width: 12.3125rem;
                      margin-left: 3.4375rem;
                      text-align: left;
                    }

                    &>div:nth-child(2) {
                      width: 9.875rem;
                      text-align: left;
                    }
                  }
                }

                .vacation_table_main_right_tips {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }
            }
          }
        }

        .appointment_table {
          /* width: 36.75rem; */
          height: 21.625rem;
          background-color: #fff;
          border-radius: 12px;

          .appointment_table_title {
            width: 100%;
            height: 2.8125rem;
            box-sizing: border-box;
            border-bottom: 1px solid #d1d1d1;
            display: flex;
            align-items: center;
            padding: 0 1.25rem;
            font-size: 0.875rem;

            &>div:nth-child(1) {
              width: 5.5rem;
            }

            &>div:nth-child(2) {
              width: 8.8125rem;
            }

            &>div:nth-child(3) {
              width: 9.875rem;
            }

            &>div:nth-child(4) {
              width: 9.4375rem;
            }

          }

          .appointment_table_main {
            height: 18.625rem;
            padding: 0 1.25rem;
            display: flex;
            align-items: center;
            position: relative;

            .rollTop {
              width: 100%;
              height: 2.5rem;
              line-height: 2.5rem;
              text-align: center;
              position: absolute;
              top: 0rem;
              left: -14.25rem;

              &>i {
                font-size: 1.4375rem;
              }
            }

            .rollBottom {
              width: 100%;
              height: 2.5rem;
              line-height: 2.5rem;
              text-align: center;
              position: absolute;
              bottom: -0.425rem;
              left: -14.25rem;

              &>i {
                font-size: 1.4375rem;
              }
            }

            .appointment_table_main_left::-webkit-scrollbar {
              width: 0.125rem !important;
            }

            .appointment_table_main_left::-webkit-scrollbar-track {
              background-color: #F0F0F0;
              border-radius: 10px;
              width: 0.25rem !important;
            }

            .appointment_table_main_left {
              width: 5.5rem;
              height: 15rem;
              display: flex;
              flex-direction: column;
              align-items: center;
              overflow-y: auto;



              .appointment_table_main_left_item {
                width: 100%;
                height: 2.5rem;
                line-height: 2.5rem;
                text-align: center;
                font-size: 0.875rem;
                color: #999;
                background-color: #f7f8f8;
                position: relative;
              }

              .appointment_table_main_left_active {
                color: #000 !important;
                background-color: #fff !important;
              }

              .appointment_table_main_left_active:before {
                content: "";
                display: block;
                width: 0.25rem;
                height: 1.125rem;
                background-color: #599fff;
                position: absolute;
                left: 0;
                top: calc(50% - 0.5625rem);
                border-radius: 10px;
              }
            }

            .appointment_table_main_right::-webkit-scrollbar-thumb {
              border-radius: 10px;
              background-color: #599fff;
            }

            .appointment_table_main_right::-webkit-scrollbar {
              width: 0.25rem !important;
            }

            .appointment_table_main_right::-webkit-scrollbar-track {
              background-color: #F0F0F0;
              border-radius: 10px;
              width: 0.25rem !important;
            }

            .appointment_table_main_right {
              width: 28.75rem;
              height: 15rem;
              overflow-y: auto;

              .appointment_table_main_right_item {
                width: 100%;
                height: 100%;

                &>div {
                  width: 100%;
                  height: 2.5rem;
                  display: flex;
                  align-items: center;
                  font-size: 0.875rem;

                  /* justify-content: space-around; */
                  &>div:nth-child(1) {
                    width: 8.8125rem;
                  }

                  &>div:nth-child(2) {
                    width: 9.875rem;
                  }

                  &>div:nth-child(3) {
                    width: 9.4375rem;
                  }
                }
              }

              .appointment_table_main_right_tips {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }

        }
      }
    }

    .we {
      width: 100%;
      height: 45.3125rem;
      background-color: #fff;

      .we_box {
        width: 62.5%;
        height: 100%;
        margin: 0 auto;

        .we_box_head {
          padding-top: 4.2875rem;
          padding-bottom: 2.875rem;
          width: 100%;
          height: auto !important;

          .we_box_head1 {
            font-size: 2rem;
            font-weight: 600;
            margin-bottom: 0.85rem;
          }

          .we_box_head2 {
            font-size: 1.125rem;
            color: #cccccc;
            font-weight: 600;
          }
        }


        .we_main {
          width: 100%;
          height: 16.875rem;
          display: flex;
          /* align-items: center; */
          justify-content: space-between;

          .we_main_left {
            width: 47%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            padding-right: 2.1875rem;

            &>div {
              text-align: left;
            }

            .we_main_left_text {
              font-size: 1.125rem;
              color: #666666;
            }

            .we_main_left_title {
              font-size: 2rem;
              font-weight: 600;
            }

            .el-button {
              padding: 0.625rem 1.875rem;
              background-color: #599fff;
              border-color: #599fff;
            }
          }

          .we_box_right {
            width: 47%;
            height: 100%;
            position: relative;

            .we_box_right_code {
              width: 10rem;
              height: 10rem;
              position: absolute;
              right: 20% !important;
              bottom: 0 !important;
            }

            &>img:nth-child(1) {
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
            }
          }
        }

        .we_box_footer {
          width: 100%;
          height: 14.75rem;
          display: flex;
          align-items: center;
          justify-content: space-between;

          &>div {

            height: 38%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;

            &>div:nth-child(1) {
              font-size: 2.25rem;
              margin-left: -0.25rem;
              font-weight: 600;

              &>span {
                font-size: 1.125rem;
                font-weight: 400;
              }
            }

            &>div:nth-child(2) {
              width: 2.5rem;
              height: 0.125rem;
              background-color: #599fff;
            }

            &>div:nth-child(3) {
              font-size: 1rem;
              color: #999999;

            }
          }
        }
      }
    }

    .consult {
      width: 100%;
      height: 68.25rem;

      .consult_head {
        padding-top: 4.2875rem;
        padding-bottom: 3rem;
        width: 100%;
        height: auto !important;

        .consult_head1 {
          font-size: 2rem;
          font-weight: 600;
          margin-bottom: 0.85rem;
        }

        .consult_head2 {
          font-size: 1.125rem;
          color: #cccccc;
          font-weight: 600;
        }
      }

      .consult_main {
        width: 74.9375rem;
        height: 46.625rem;
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(3, 24rem);
        grid-template-rows: repeat(2, 22.4375rem);
        row-gap: 1.25rem;
        column-gap: 1.25rem;

        &>div {
          background-color: #fff;
          padding: 1.25rem;
          border-radius: 6px;
          text-align: left;

          &>img {
            width: 21.5rem;
            height: 11.625rem;
          }

          .NewsConsult_title {
            font-size: 1.125rem;
            font-weight: 600;
            overflow: hidden;
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            -webkit-line-clamp: 1;
            margin: 1.25rem 0 2rem;
          }

          .NewsConsult_desc {
            font-size: 1rem;
            color: #666;
            margin-bottom: 1.25rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }

          .NewsConsult_Time {
            font-size: 0.875rem;
            color: #999999;
          }
        }
      }

      .el-button {
        background-color: #599fff !important;
        border: #599fff !important;
        margin: 2.0625rem auto 0;
        padding: 0.75rem 2.5rem;
      }      
    }

    .maks1 {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, .8);
	}

	.qrcode1 {
		width: 600px;
		height: 400px;
		background-color: #FFF;
		border-radius: 10px;
		// position: relative;
		top: calc(50% - 200px);
		left: calc(50% - 300px);
		position: absolute;
		z-index: 10000;
		.el-icon-close{
			position: absolute;
			top: 10px;
			right: 10px;
			font-size: 25px;
			cursor: pointer;
		}
		.qrcode-title{
			margin-top: 16px;
			font-size: 18px;
		}
		&>img {
			width: 600px;
			height: 400px;
			// position: absolute;
			// top: calc(50% - 80px);
			// left: calc(50% - 100px);
		}
	}
  }

</style>



// WEBPACK FOOTER //
// src/page/index/index.vue